import axios from 'axios'

/**
 * pull a user-facing message off any error coming back from the api. server
 * errors come through the AppError envelope, which is flat (`statusCode`,
 * `error` code, `message`, `requestId`), so the human message is `body.message`.
 * non-axios failures (network, JS errors) fall through to a generic string.
 */
export function extractErrorMessage(failure: unknown): string {
  if (axios.isAxiosError(failure)) {
    const body = failure.response?.data as { message?: string } | undefined
    return body?.message ?? failure.response?.statusText ?? failure.message
  }
  return 'Something went wrong. Please try again.'
}
